export default __webpack_public_path__ + "static/media/trash.2763fde4.svg";